import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { redirect, useParams, Navigate, useNavigate } from "react-router-dom";
import errorToast from "../../components/utilites/errorToast";
import successToast from "../../components/utilites/successToast";
import { verifyEmail } from "../../redux/actions/authActions";
import "./signupverification.css";
import SuccessPopup from "../../components/Popups/SuccessPopUp";
import ErrorPopup from "../../components/Popups/ErrorPopup";

const EmailVerificationLink = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(null);
  // const [navigateUrl, setNavigateUrl] = useState("/verified");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showErrorPopup1, setShowErrorPopup1] = useState(false);
  const [showErrorMsg1, setShowErrorMsg1] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState("");

  useEffect(() => {
    dispatch(verifyEmail(params.id, onSuccess, onError));
  }, []);

  const timeOutFnc = () => {
    setLoading(false);
    setVerified(true);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
    navigate("/login");
  };

  const onSuccess = (data) => {
    console.log(data);

    setLoading(true);

    if (data.status == "409") {
      setVerified(false);
      setLoading(false);
      setShowErrorPopup(true);
      const str = data.data.message;
      const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
      setShowErrorMsg(str_modify);
      setTimeout(closeErrorPopup, 2000);
    }
    if (data.status == "200") {
      setTimeout(timeOutFnc, 2000);
    }

  };

  const closeErrorPopup1 = () => {
    setShowErrorPopup1(false);
    navigate("/login");
  };
  const onError = (err) => {
    console.log(err);
    setVerified(false);
    setLoading(false);
    const str1 = err.data.message;
    const str_modify1 = str1.charAt(0).toUpperCase() + str1.slice(1);
    setShowErrorMsg1(str_modify1);
    setShowErrorPopup1(true);
    setTimeout(closeErrorPopup1, 2000);
  };

  return loading ? (
    <div className="d-flex justify-content-center align-items-center spinner-container">
      <Spinner />
    </div>
  ) : verified == true ? (
    <>
      <Navigate to={"/verified"} />
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
    </>
  ) : (
    <>
      {/* <Navigate to={"/login"} /> */}
      <ErrorPopup show={showErrorPopup} title={showErrorMsg} />

      <ErrorPopup show={showErrorPopup1} title={showErrorMsg1} />
    </>
  );
};

export default EmailVerificationLink;
